import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row q-ma-lg export-dates" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 q-mb-lg" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Equipments")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "q-mr-xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Start date (yyyy/mm/dd)", -1 /* HOISTED */)
const _hoisted_5 = { class: "row items-center justify-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "End date (yyyy/mm/dd)", -1 /* HOISTED */)
const _hoisted_7 = { class: "row items-center justify-end" }
const _hoisted_8 = {
  key: 0,
  class: "export"
}
const _hoisted_9 = { class: "row q-ml-lg q-my-lg" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "title q-mt-sm" }, "Spare Parts", -1 /* HOISTED */)
const _hoisted_11 = {
  key: 0,
  class: "q-ml-xl"
}
const _hoisted_12 = { class: "row q-ml-lg q-my-lg" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title q-mt-sm font-width-bold" }, "Turbines Serial Number", -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "q-ml-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_q_input, {
          modelValue: _ctx.startDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
          "data-test": "equipment-tag",
          outlined: "",
          mask: "date",
          rules: ['date'],
          dense: ""
        }, {
          append: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "event",
              class: "cursor-pointer"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy",
                  cover: "",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                      options: _ctx.rangeOptions
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _withDirectives(_createVNode(_component_q_btn, {
                            label: "Close",
                            color: "primary",
                            flat: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_directive_close_popup]
                          ])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createVNode(_component_q_input, {
          modelValue: _ctx.endDate,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
          outlined: "",
          mask: "date",
          rules: ['date'],
          dense: ""
        }, {
          append: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "event",
              class: "cursor-pointer"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy",
                  cover: "",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event)),
                      options: _ctx.rangeOptions
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _withDirectives(_createVNode(_component_q_btn, {
                            label: "Close",
                            color: "primary",
                            flat: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_directive_close_popup]
                          ])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      (!_ctx.isUserUnknownFn())
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_q_btn, {
              outline: "",
              rounded: "",
              "no-caps": "",
              label: "Export data for the period",
              class: "action-button export-button",
              disable: !_ctx.startDate || !_ctx.endDate,
              "data-test": "export-excel",
              onClick: _ctx.exportExcel
            }, null, 8 /* PROPS */, ["disable", "onClick"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_q_separator),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      (!_ctx.isUserUnknownFn())
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_q_btn, {
              outline: "",
              rounded: "",
              "no-caps": "",
              label: "Export missing spare parts",
              class: "action-button export-button",
              onClick: _ctx.exportMissingSpareParts
            }, null, 8 /* PROPS */, ["onClick"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_q_separator),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      (!_ctx.isUserUnknownFn())
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_q_btn, {
              outline: "",
              rounded: "",
              "no-caps": "",
              label: "Export S/N",
              class: "action-button export-button",
              onClick: _ctx.exportSerialNumber
            }, null, 8 /* PROPS */, ["onClick"])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}